import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import AllReducers from '../../Reducers';

export const store = createStore(AllReducers, applyMiddleware(thunk)); 
export const persistor = persistStore(store);
